import { useMembershipModalState } from '../../modalContext';

export function useShowVenmoButton(): boolean {
	const [
		{
			paymentType,
			usingSavedPaymentMethod,
			acceptMembership,
			tokenizationData,
			savingBraintreePaymentTemporarilyEnabled,
		},
	] = useMembershipModalState();

	return (
		paymentType === 'venmo' &&
		!usingSavedPaymentMethod &&
		tokenizationData?.tokenType !== 'permanent' &&
		!savingBraintreePaymentTemporarilyEnabled &&
		acceptMembership
	);
}
